import { history } from '../store/index';
import { store } from '../../NextApp';
import { generateQueryString } from "../../util/Api";

import {
  ADD_TO_MERGE_LIST,
  CREATE_SPARE_PART_SUCCESS,
  FETCH_SPARE_PART_SUCCESS,
  GET_ALL_SPARES_START,
  GET_ALL_SPARES_SUCCESS,
  GET_SPARE_COMPATIBLE_SUCCESS,
  GET_SPARE_FOR_SUBASSEMBLY_SUCCESS,
  GET_SPARE_PART_SUCCESS,
  SAVE_SPARE_PART_QUERY,
  SPARE_MERGE_SUCCESS,
  SPARE_NAME_GENERATE_CLEAR,
  SPARE_NAME_GENERATE_SUCCESS
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import { fetchError, fetchFilter, fetchStart, fetchSuccess } from "./Common";
import { getUser } from "./Auth";
import { message } from "antd";
import { arrayToCSV, downloadCSV } from "../../util/methods";


export const getResourceSuccess = ({ data, count }) => {
  return {
    type: GET_SPARE_PART_SUCCESS,
    data,
    count,
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_SPARE_PART_QUERY,
    query
  };
};

export const createResourceSuccess = ({ data }) => {
  return {
    type: CREATE_SPARE_PART_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({ data }) => {
  return {
    type: FETCH_SPARE_PART_SUCCESS,
    data
  };
};


export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { sparePart } = store.getState();
      const { query } = sparePart;
      const response = await axios.get(`/spare-part?${generateQueryString(query)}`);

      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      // message.error(error.response.data.message);
      message.error("Record not found");
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { sparePart } = store.getState();
      const { query } = sparePart;
      const response = await axios.get(`/spare-part/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const createResource = (payload, redirect = true, module) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.post(`/spare-part`, payload);

      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      } else {
        dispatch(fetchSuccess());
        dispatch(createResourceSuccess({ data: response.data }));
      }
      if (!redirect) {
        dispatch(fetchFilter(module));
      } else {
        history.push('/spare-part');
        dispatch(getResource());
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.put(`/spare-part/${id}`, payload);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      dispatch(getUser());
      history.push('/spare-part');
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/spare-part/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());
    try {
      await axios.delete(`/spare-part/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const fetchVoucherByType = (type, id) => {
  const code = id.replace(/\//g, "|");
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/common/voucher-id/${type}/${code}`);
      dispatch(fetchSuccess());
      if (response.data) {
        if (type === 'purchase' || type === 'PO')
          window.open(`/purchase-order/view/${response.data}`, '_blank');
        if (type === 'issue' || type === 'ISSUE' || type === 'SPI')
          window.open(`/spares-issue/edit/${response.data}`, '_blank');
        if (type === 'receipt' || type === 'RECEIPT' || type === 'SRA')
          window.open(`/spare-receipt-advise/edit/${response.data}`, '_blank');
        if (type === 'transfer' || type === 'TRANSFER' || type === 'STA')
          window.open(`/spare-transfer-advice/edit/${response.data}`, '_blank');
        if (type === 'TINV' || type === 'TPW' || type === 'INVOICE')
          window.open(`/invoice-entry/edit/${response.data}`, '_blank');
      }
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getAllSpares = () => {
  return async dispatch => {
    dispatch(getAllSparesStart());
    try {
      const response = await axios.get(`/spare-part/organisation/all`);
      dispatch(getAllSparesOk({ data: response.data }));
    } catch (error) {
      dispatch(getAllSparesOk({ data: [] }));
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  };
};

export const getAllSparesOk = ({ data }) => {
  return {
    type: GET_ALL_SPARES_SUCCESS,
    data
  };
};

export const getAllSparesStart = () => {
  return {
    type: GET_ALL_SPARES_START
  };
};

export const addSpareListToMergeList = (data, isAdded = true) => {
  return async dispatch => {
    let newData = [];
    if (data && data.length > 0) {
      const { sparePart } = store.getState();
      const { mergeableSpares } = sparePart;

      if (isAdded) {
        newData = data; // arrayUnique([].concat(mergeableSpares, data));
      } else {
        // newData = mergeableSpares.filter(doc => doc.sparePartId !== data.sparePartId);
      }
    }
    try {
      dispatch(addToMergeListSuccess(newData));
      if (newData.length) {
        message.success(`${newData.length} spares added for merging`)
      }
    } catch (error) {
      // dispatch(addToMergeListSuccess({ data: [] }));
      dispatch(fetchError(error.message));
      console.log("Error****:", error);
    }
  };
};

export const addToMergeList = (data, isAdded = true) => {
  return async dispatch => {
    let newData = [];
    if (data && data.length === 0) {
    } else {
      const { sparePart } = store.getState();
      const { mergeableSpares } = sparePart;
      if (!data)
        newData = mergeableSpares;
      else {
        if (isAdded)
          newData = [].concat(mergeableSpares, [data]);
        else {
          newData = mergeableSpares.filter(doc => doc.sparePartId !== data.sparePartId);
        }
      }
    }
    try {
      dispatch(addToMergeListSuccess(newData));
      if (newData.length) {
        message.success(`${newData.length} spares added for merging`)
      }
    } catch (error) {
      // dispatch(addToMergeListSuccess({ data: [] }));
      dispatch(fetchError(error.message));
      console.log("Error****:", error);
    }
  };
};

export const addToMergeListSuccess = (data) => {
  return {
    type: ADD_TO_MERGE_LIST,
    data
  };
};

export const mergeSpares = (original, spares = []) => {
  return async dispatch => {
    dispatch(fetchStart());
    try {
      const response = await axios.post(`common/merge/spare-merge`, {
        destination_spare: original,
        source_spares: spares
      });
      dispatch(fetchSuccess());
      if (response && (response.status === 200 || response.status === 201)) {
        console.log(response.data);
        downloadFile(response.data);
        message.success(`Merge is successful`);
        dispatch(addToMergeListSuccess([]));
        history.goBack();
        // dispatch(fetchMergeSuccess({data: response.data}));
      } else {
        console.log(response);
        message.error(response.data && response.data.message)
      }
    } catch (error) {
      // dispatch(addToMergeListSuccess({ data: [] }));
      dispatch(fetchError(error.message));
      console.log("Error****:", error);
    }
  };
};

export const fetchMergeSuccess = ({ data }) => {
  return {
    type: SPARE_MERGE_SUCCESS,
    data
  };
};

const downloadFile = (myData, name = "spare-merge.log") => {
  const fileName = name;
  const json = JSON.stringify(myData, null, 2);
  const blob = new Blob([json], { type: "application/json" });
  const href = URL.createObjectURL(blob);
  // create "a" HTLM element with href to file
  const link = document.createElement("a");
  link.href = href;
  link.download = fileName + ".json";
  document.body.appendChild(link);
  link.click();
  // clean up "a" element & remove ObjectURL
  document.body.removeChild(link);
  URL.revokeObjectURL(href);
};

const arrayUnique = (array, field = 'sparePartId') => {
  let a = array.concat();
  for (let i = 0; i < a.length; ++i) {
    for (let j = i + 1; j < a.length; ++j) {
      if (a[i][field] === a[j][field])
        a.splice(j--, 1);
    }
  }
  return a;
};

export const transferSpare = (name, code, oldSpare, newSpare) => {
  return async dispatch => {
    dispatch(fetchStart());
    try {
      const new_code = code.replace(/\//g, "|");
      const response = await axios.get(`common/transfer/spare-transfer/${name}/${new_code}/${oldSpare}/${newSpare}`);
      dispatch(fetchSuccess());
      if (response && (response.status === 200 || response.status === 201)) {
        // console.log(response.data);
        if (response.data.error) {
          message.error(response.data.error);
        } else {
          downloadFile(response.data, 'spare-transfer.log');
          message.success(`Transfer is successful`);
          dispatch(addToMergeListSuccess([]));
        }
      } else {
        console.log(response);
        message.error(response.data && response.data.message)
      }
    } catch (error) {
      dispatch(fetchError(error.message));
      console.log("Error****:", error);
    }
  };
};

export const generateSparePartName = (payload) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      let name = payload.givenName.toUpperCase();
      const attributes = [];
      const newPayload = {};
      for (const [key, value] of Object.entries(payload)) {
        if (key.indexOf('_code') !== -1) {
          attributes.push({ attribute: key.split('_')[0], code: value });
        } else if (key.indexOf('_name') !== -1) {
          attributes.push({ attribute: key.split('_')[0], name: value });
        } else
          newPayload[key] = value;
      }
      let items = {};
      attributes.forEach(item => items[item.attribute] = { ...items[item.attribute], ...item });
      newPayload['typeAttributes'] = Object.values(items) || [];
      // console.log(payload, newPayload, attributes);
      newPayload['typeAttributes'].map(atr => {
        if (atr.code && atr.code !== '') {
          name += `-${atr.code.toUpperCase()}`;
        } else {
          name += `-${atr.name.toUpperCase()}`;
        }
      });
      newPayload['name'] = name;
      console.log(newPayload);
      dispatch(fetchSuccess());
      dispatch(sparePartNameGenerationSuccess({ data: newPayload, name, }));
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const sparePartNameGenerationSuccess = ({ data, name }) => {
  return {
    type: SPARE_NAME_GENERATE_SUCCESS,
    data,
    name
  };
};

export const sparePartNameGenerationClear = () => {
  return async (dispatch) => {
    dispatch({
      type: SPARE_NAME_GENERATE_CLEAR
    });
  }
};


export const createNewSpare = (id = null, redirect = true, module) => {
  return async (dispatch) => {
    const { sparePart } = store.getState();
    const { submitPayload: payload, generatedSpareName } = sparePart;
    // console.log(payload)
    payload['name'] = generatedSpareName;
    // payload['code'] = (new Date().getTime() % 10000000 + 10000000).toString().slice(-7);
    dispatch(fetchStart());
    try {

      let formData = new FormData();

      let response = null;
      if (id) {
        const documentData = [];
        const documentIds = [];
        payload.documents &&
          payload.documents.map((item, index) => {
            if (!item.file.path) {
              formData.append("files", item.file);
              let data = { ...item };
              delete data.file;
              documentData.push(data);
            } else {
              documentIds.push(item._id);
            }
          });

        formData.append("documentData", JSON.stringify(documentData));
        formData.append("documentIds", JSON.stringify(documentIds));

        Object.keys(payload).forEach(key => {
          if (key === "documents") {
            return;
          }

          if (!payload[key]) {
            return;
          }

          // If value is an array or object, stringify it
          if (Array.isArray(payload[key]) || (typeof payload[key] === 'object' && payload[key] !== null)) {
            formData.append(key, JSON.stringify(payload[key]));
          } else {
            formData.append(key, payload[key]);
          }
        });
        response = await axios.put(`/spare-part/new/${id}`, formData, {
          config: { headers: { "Content-Type": "multipart/form-data" } }
        });
      } else {
        const documentData = [];
        payload.documents &&
          payload.documents.map((item, index) => {
            formData.append("files", item.file);
            let data = { ...item };
            delete data.file;
            documentData.push(data);
          });

        formData.append("documentData", JSON.stringify(documentData));

        Object.entries(payload).forEach(([key, value]) => {
          if (key === "documents") {
            return;
          }
          if (!value) {
            return;
          }
          // formData.append(key, payload[key]);
          if (Array.isArray(value)) {
            // If the value is an array, handle it accordingly
            value.forEach((item, index) => {
              Object.entries(item).forEach(([nestedKey, nestedValue]) => {
                formData.append(`${key}[${index}][${nestedKey}]`, nestedValue);
              });
            });
          } else {
            // For non-array values
            formData.append(key, value);
          }
        });
        // console.log(formData)
        response = await axios.post(`/spare-part/new`, formData, {
          config: { headers: { "Content-Type": "multipart/form-data" } }
        });
      }
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      } else {
        dispatch(fetchSuccess());
        dispatch(createResourceSuccess({ data: response.data }));
        dispatch(sparePartNameGenerationClear());
      }
      if (!redirect) {
        dispatch(fetchFilter(module));
      } else {
        history.push('/spare-part');
        dispatch(getResource());
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const getCompatibleSpares = (spare) => {
  return async dispatch => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/spare-part/compatible/${spare}`);
      dispatch(getCompatibleSpareSuccess({ data: response.data }));
      dispatch(fetchSuccess());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  };
};

export const getCompatibleSpareSuccess = ({ data }) => {
  return async (dispatch) => {
    dispatch({
      type: GET_SPARE_COMPATIBLE_SUCCESS,
      data
    });
  }
};

export const getSubAssemblySpares = (modelId) => {
  return async dispatch => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/spare-part/sub-assembly-spares/${modelId}`);
      dispatch(getSubAssemblySparesSuccess({ data: response.data }));
      dispatch(fetchSuccess());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  };
};

export const getSubAssemblySparesSuccess = ({ data }) => {
  return async (dispatch) => {
    dispatch({
      type: GET_SPARE_FOR_SUBASSEMBLY_SUCCESS,
      data
    });
  }
};
